import { Checkbox, CheckboxProps } from 'antd';
import clx from 'classnames';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useInputController } from '../../hooks/useInputController';
import { useFormItemAccessibility } from '../../item/useFormItemAccessibility';

const StyledComputedCheckbox = styled(Checkbox)`
  &.read-only {
    pointer-events: none;
  }
`;

export interface IComputedCheckboxInputProps
  extends Omit<CheckboxProps, 'name'> {
  name: string;
  checked: boolean;
  /**
   * Aggungiamo proprietà readOnly non gestita da antd
   */
  readOnly?: boolean;
}

/**
 * Simile al checkbox input, ma il valore è statico e non può essere modificato
 * dall'utente. Il campo viene comunque registrato nei form.
 */
export function ComputedCheckboxInput(props: IComputedCheckboxInputProps) {
  const { name, checked, readOnly, className, ...inputProps } = props;

  const {
    field: { value, onChange },
  } = useInputController(name, { enabled: true });

  useEffect(() => {
    if (readOnly) return;
    if (value !== checked) {
      onChange(checked);
    }
  }, [value, onChange, checked, readOnly]);

  const accessibility = useFormItemAccessibility();

  return (
    <StyledComputedCheckbox
      {...accessibility.attributes}
      {...inputProps}
      checked={value}
      disabled={false}
      onChange={() => {}}
      className={clx(className, { 'read-only': readOnly })}
    />
  );
}
